<template>
  <div class="tags-view">
    <a-tabs
      size="small"
      type="editable-card"
      hideAdd
      :activeKey="tab"
      :tabBarGutter="0"
      @edit="onEdit"
      @change="onChange"
    >
      <a-tab-pane
        v-for="route in activeRoutes"
        :key="route.materialType ? (route.path + '?materialId=' + route.materialType.id) : route.path"
        :tab="route.materialType ? ($t(route.name) + '（' + route.materialType.name + '）' ): ($t(route.name) + route.planId)"
      ></a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { defineComponent, reactive, watch, computed } from '@vue/composition-api'
import { materialRouter } from '../../../router/modules/material'
export default defineComponent({
  setup(_, ctx) {
    const getMaterialType = () => {
      if (ctx.root.$store.state.app.current === 'material') {
        console.log('属于material',ctx)
        
        if(ctx.root._route.path == '/material/basics/statisticalReport/stock' || (ctx.root._route.path == '/material/basics/statisticalReport/record') || (ctx.root._route.path == '/material/basics/delivery-plan')) {
          return ''
        }
        else {
          const materialTypeList = ctx.root.$store.state.permission.wmsRoutes
          const materialId = ctx.root.$route.query.materialId
          if (!materialTypeList || materialTypeList.length === 0) {
            return {} 
          }
          if (materialId) {
            return materialTypeList.find(res => res.id === materialId)
          }
          return materialTypeList[0]
        }
      }
    }
    const state = reactive({
      activeRoute: {},
      activeRoutes: [],
      planId: computed(() => {
        const s = ctx.root.$route.path.split('/')
        const n = s[s.length - 1]
        if (['1', '2', '3', '4', '5'].includes(n)) {
          return n
        } else {
          return ''
        }
      }),
      materialType: computed(() => {
        // 当前是物料app 找到当前的库区类型
        return getMaterialType()
      })
    })

    watch(
      () => ctx.root.$route.path,
      (curr, prev) => {
        console.log('监听',curr)
        if (curr.includes('redirect')) return
        // 物料
        console.log(ctx.root.$store.getters)
        if (ctx.root.$store.getters.currentApp === 'material') {
          if (state.activeRoutes.findIndex((r) => (r.path === curr && r.materialType.id === ctx.root.$route.query.materialId)) !== -1) {
            return
          }
        } else if (state.activeRoutes.findIndex((r) => r.path === curr) !== -1) {
          return
        }
        console.log(ctx.root.$store.getters.routeDict,'routeDict')
        let name = ctx.root.$store.getters.routeDict[curr]
        if (ctx.root.$store.state.app.current === 'material') {
            materialRouter.forEach(res => {
              if (res.path === curr) {
                name = res.name
              }
            })
        }
        let route = {}
        console.log(ctx.root._route.fullPath,'path')
        if(ctx.root._route.fullPath.indexOf('/material') != -1  && ctx.root._route.fullPath.indexOf('?materialId') === -1 && ctx.root.$store.getters.currentApp === 'material'){
          route = {
            path: ctx.root._route.fullPath,
            name: ctx.root._route.name,
            // code: store.getters.routeDict[curr],
            planId: '',
            materialType: getMaterialType()
          }
          state.planId = ''
        }
        else {
          route = {
            path: curr,
            name: name,
            // code: store.getters.routeDict[curr],
            planId: state.planId,
            materialType: getMaterialType()
          }
        }

        console.log(route,'a')
        state.activeRoutes.push(route)
        state.activeRoute = { ...route }
      },
      { immediate: true }
    )

    const onEdit = (key) => {
      if (state.activeRoutes.length === 1) return
      // 物料
      const index = state.activeRoutes.findIndex((r) => {
        if (r.materialType) {
          return ((r.path+'?materialId=' + r.materialType.id) === key)
        } else {
          return r.path === key
        }
      })
      state.activeRoutes.splice(index, 1)
      if (state.activeRoute.path === key) {
        const prev = state.activeRoutes[0]
        ctx.root.$router.push(prev.path)
        state.activeRoute = { ...prev }
      }
    }

    const onChange = (key) => {
      ctx.root.$router.push({ path: key })
      const appRouteList = ctx.root.$store.state.permission.appRouteMap || []
      let appCode = ''
      let appName = ''
      appRouteList.forEach(res => {
        res.routes.forEach(re => {
          if (re.path === key) {
            appCode = res.appCode
            appName = res.appName
          }
        })
      })
      ctx.root.$store.dispatch('app/setAppName', appName)
      ctx.root.$store.dispatch('app/setCurrentApp', appCode)
      // 物料
      const index = state.activeRoutes.findIndex((r) => {
        if (r.materialType) {
          return ((r.path+'?materialId=' + r.materialType.id) === key)
        } else {
          return r.path === key
        }
      })
      state.activeRoute = { ...state.activeRoutes[index] }
    }    

    const routerTo = (link) => {
      ctx.root.$router.push(link)
    }

    const tab = computed(() => {
      return ctx.root.$store.getters.currentApp === 'material' ? (ctx.root.$route.path + '?materialId=' + ctx.root.$route.query.materialId) : ctx.root.$route.path
    })

    return { ...state, onEdit, onChange, tab, routerTo }
  },
})
</script>

<style lang="less" scoped>
.tags-view {
  // height: 32px;
  /deep/ .ant-tabs .ant-tabs-small-bar .ant-tabs-nav-container {
    font-size: 12px;
  }
  /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
    line-height: 20px;
  }
  /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
    height: 24px;
  }
  /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {
    height: 24px;
  }
  /deep/ .ant-tabs-bar {
    margin: 0;
  }
  /deep/ .ant-tabs-nav-scroll {
    background-color: #d8d8d8;
  }
}
/deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
  background-color: #d8d8d8;
}
/deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  background: #F0F2F5;
  border-bottom: 1px solid #F0F2F5
}
</style>
